module.exports = __webpack_public_path__ + "img/ja-logo-black.db0c23e4.svg";